import { updateItemInCollection } from "directus/src/operations";

export async function updateBillable({ billableId, item }) {
    try {
        const query = {
            fields: [
                "id",
                "name",
                "milestones",
                "job",
                "type",
                "amount",
                "adjusted_amount",
                "status",
                "billing_date",
                "due_date",
                "due_days",
                "invoice_number",
                "invoiced_date",
                "collected_date",
                "note",
                "fixed_billing_config.approved_hours_threshold",
                "hourly_billing_config.start_date",
                "hourly_billing_config.end_date",
                "hourly_billing_config.billable_hours",
                "dedicated_billing_config.working_days",
                "dedicated_billing_config.billable_days",
                "dedicated_billing_config.start_date",
                "dedicated_billing_config.end_date",
            ],
        };

        const data = await updateItemInCollection("billables", billableId, item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
